// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"27115902","267":"d878a250","404":"2fd1372e","630":"193bdf4b"}[chunkId] + ".chunk.js";
};